import React, { useRef, useState } from "react";
import PersonalInfoForm from "./PersonalInfoForm";
import ExperienceForm from "./ExperienceForm";
import SkillsForm from "./SkillsForm";
import { FormProvider, useFormContext } from "../contexts/FormContext";

const steps = [
  { title: "Informations personnelles", icon: "👤", description: "Vos coordonnées" },
  { title: "Compétences", icon: "⚡", description: "Vos expertises" },
  { title: "Expériences", icon: "💼", description: "Votre parcours" },
];

const ConsultantFormContent: React.FC = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [step, setStep] = useState(0);
  const { submitForm, isSubmitting, loadConsultantByEmail, resetForm, consultantId, cvId, isLoadingProfile, validationError, validateStep, clearValidationError, currentUser, isLoadingUser } = useFormContext();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  // const [searchEmail, setSearchEmail] = useState("");
  const [searchError, setSearchError] = useState("");
  const [formSubmittedSuccessfully, setFormSubmittedSuccessfully] = useState(false);
  const profileCreationStarted = useRef(false);

  const handleCreateNew = () => {
    profileCreationStarted.current = true; // ne déclenche pas de re-render
    resetForm();
    resetForm();
    setShowWelcome(false);
    setStep(0);
    setFormSubmittedSuccessfully(false);
  };

  // const handleLoadProfile = async () => {
  //   if (!searchEmail.trim()) {
  //     setSearchError("Veuillez entrer une adresse email");
  //     return;
  //   }
  //   setSearchError("");
  //   const found = await loadConsultantByEmail(searchEmail);
  //   if (found) {
  //     setShowWelcome(false);
  //     setStep(0);
  //     setFormSubmittedSuccessfully(false);
  //   } else {
  //     setSearchError("Aucun profil trouvé avec cet email");
  //   }
  // };

  if (!consultantId && currentUser && !profileCreationStarted.current) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)",
        padding: "1rem",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
      }}>
        <div style={{
          width: "100%",
          maxWidth: "600px",
          margin: "0 auto",
          background: "#fff",
          borderRadius: "24px",
          boxShadow: "0 20px 60px rgba(30, 60, 115, 0.08), 0 0 1px rgba(0,0,0,0.1)",
          overflow: "hidden"
        }}>
          {/* Header with Logo */}
          <div style={{
            background: "linear-gradient(135deg, #1E3C73 0%, #2a5298 100%)",
            padding: "2.5rem 2rem 2rem",
            color: "white",
            position: "relative",
            overflow: "hidden"
          }}>
            <div style={{
              position: "absolute",
              top: "-50px",
              right: "-50px",
              width: "200px",
              height: "200px",
              background: "rgba(255, 145, 0, 0.1)",
              borderRadius: "50%",
              filter: "blur(40px)"
            }}></div>
            
            <div style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "1rem",
              position: "relative"
            }}>
              <img
                src="/favicon.png"
                alt="JLC"
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "contain",
                  filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))"
                }}
              />
            </div>
            <h1 style={{
              fontSize: "1.75rem",
              fontWeight: 700,
              margin: "0 0 0.5rem 0",
              textAlign: "center",
              position: "relative",
              letterSpacing: "-0.02em"
            }}>
              Bienvenue {currentUser.name} ! 👋
            </h1>
            <p style={{
              fontSize: "1rem",
              margin: 0,
              textAlign: "center",
              opacity: 0.95,
              position: "relative",
              fontWeight: 400
            }}>
              Créez votre profil consultant
            </p>
          </div>

          {/* Content */}
          <div style={{ padding: "2.5rem 2rem 3rem" }}>
            <div style={{
              background: "#f0f9ff",
              padding: "1.5rem",
              borderRadius: "12px",
              border: "2px solid #0ea5e9",
              marginBottom: "2rem"
            }}>
              <p style={{
                margin: 0,
                fontSize: "1rem",
                color: "#0c4a6e",
                lineHeight: 1.6
              }}>
                Vous n'avez pas encore de profil consultant. Créez-le maintenant en quelques étapes simples !
              </p>
            </div>

            <button
              type="button"
              onClick={handleCreateNew}
              style={{
                width: "100%",
                padding: "1.25rem",
                fontSize: "1.1rem",
                fontWeight: 600,
                color: "white",
                background: "linear-gradient(135deg, #FF9100 0%, #FFA726 100%)",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                transition: "all 0.3s",
                fontFamily: "inherit",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.75rem",
                boxShadow: "0 4px 14px rgba(255, 145, 0, 0.3)"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(255, 145, 0, 0.45)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 14px rgba(255, 145, 0, 0.3)";
              }}
            >
              <span style={{ fontSize: "1.375rem" }}>✨</span>
              <span>Créer mon profil</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await submitForm();
    if (success) {
      setShowSuccess(true);
      setFormSubmittedSuccessfully(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }
  };

  const handleFormKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === 'Enter' && step < steps.length - 1) {
      const target = e.target as HTMLElement;
      if (target.tagName !== 'TEXTAREA') {
        e.preventDefault();
      }
    }
  };

  const handleNext = (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    // Validate current step before moving to next
    if (validateStep(step)) {
      setStep(prev => Math.min(prev + 1, steps.length - 1));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePrev = (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    clearValidationError();
    setStep(prev => Math.max(prev - 1, 0));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPage = () => {
    switch (step) {
      case 0:
        return <PersonalInfoForm />;
      case 1:
        return <SkillsForm />;
      case 2:
        return <ExperienceForm />;
      default:
        return <PersonalInfoForm />;
    }
  };

  const progressPercentage = ((step + 1) / steps.length) * 100;

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)",
      padding: "1rem",
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
    }}>
      {/* Success Toast */}
      {showSuccess && (
        <div style={{
          position: "fixed",
          top: "2rem",
          right: "2rem",
          background: "#10b981",
          color: "white",
          padding: "1rem 1.5rem",
          borderRadius: "12px",
          boxShadow: "0 10px 40px rgba(16, 185, 129, 0.3)",
          zIndex: 1000,
          animation: "slideInRight 0.3s ease-out",
          fontSize: "1rem",
          fontWeight: 500,
          minWidth: "320px"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
            <span style={{ fontSize: "1.5rem" }}>✓</span>
            <span>Formulaire enregistré avec succès !</span>
          </div>
        </div>
      )}

      <div style={{
        width: "100%",
        maxWidth: "800px",
        margin: "0 auto",
        background: "#fff",
        borderRadius: window.innerWidth < 768 ? "16px" : "24px",
        boxShadow: "0 20px 60px rgba(30, 60, 115, 0.08), 0 0 1px rgba(0,0,0,0.1)",
        overflow: "hidden",
        transition: "all 0.3s ease"
      }}>
        {/* Header Section */}
        <div style={{
          background: "linear-gradient(135deg, #1E3C73 0%, #2a5298 100%)",
          padding: window.innerWidth < 768 ? "2rem 1.5rem 1.5rem" : "2.5rem 2rem 2rem",
          color: "white",
          position: "relative",
          overflow: "hidden"
        }}>
          <div style={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: "200px",
            height: "200px",
            background: "rgba(255, 145, 0, 0.1)",
            borderRadius: "50%",
            filter: "blur(40px)"
          }}></div>
          <div style={{
            position: "absolute",
            bottom: "-30px",
            left: "-30px",
            width: "150px",
            height: "150px",
            background: "rgba(255, 145, 0, 0.1)",
            borderRadius: "50%",
            filter: "blur(30px)"
          }}></div>
          {/* Logo */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "1rem",
            position: "relative"
          }}>
            <img
              src="/favicon.png"
              alt="JLC"
              style={{
                width: "80px",
                height: "80px",
                objectFit: "contain",
                filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))"
              }}
            />
          </div>
          <h1 style={{
            fontSize: "1.75rem",
            fontWeight: 700,
            margin: "0 0 0.5rem 0",
            textAlign: "center",
            position: "relative",
            letterSpacing: "-0.02em"
          }}>
            Espace JLCTalents
          </h1>
          <p style={{
            fontSize: "1rem",
            margin: 0,
            textAlign: "center",
            opacity: 0.95,
            position: "relative",
            fontWeight: 400
          }}>
            Générez votre CV en trois étapes
          </p>
        </div>

        {/* Progress Bar */}
        <div style={{
          background: "#f8f9fa",
          padding: "0",
          borderBottom: "1px solid #e5e7eb"
        }}>
          <div style={{
            height: "6px",
            background: "#e5e7eb",
            position: "relative",
            overflow: "hidden"
          }}>
            <div style={{
              height: "100%",
              background: "linear-gradient(90deg, #FF9100 0%, #ffb347 100%)",
              width: `${progressPercentage}%`,
              transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 0 10px rgba(255, 145, 0, 0.5)"
            }}></div>
          </div>
        </div>

        {/* Success notification when profile loaded */}
        {consultantId && (
          <div style={{
            background: "#d1fae5",
            borderBottom: "1px solid #6ee7b7",
            padding: "0.75rem 2rem",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem"
          }}>
            <span style={{ fontSize: "1.25rem" }}>✓</span>
            <span style={{ fontSize: "0.95rem", color: "#065f46", fontWeight: 500 }}>
              Profil chargé - Vos données sont pré-remplies
            </span>
          </div>
        )}

        {/* Step Indicators */}
        <div style={{
          display: "flex",
          justifyContent: "space-around",
          padding: "1.5rem 1rem",
          background: "#fafbfc",
          borderBottom: "1px solid #e5e7eb"
        }}>
          {steps.map((s, idx) => (
            <div
              key={idx}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                cursor: idx <= step ? "pointer" : "default",
                opacity: idx <= step ? 1 : 0.4,
                transition: "all 0.3s ease"
              }}
              onClick={() => idx <= step && setStep(idx)}
              role="button"
              tabIndex={idx <= step ? 0 : -1}
              aria-label={`Étape ${idx + 1}: ${s.title}`}
              aria-current={step === idx ? "step" : undefined}
            >
              <div style={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                background: step === idx 
                  ? "linear-gradient(135deg, #1E3C73 0%, #2a5298 100%)"
                  : step > idx 
                    ? "#10b981" 
                    : "#e5e7eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.5rem",
                marginBottom: "0.5rem",
                transition: "all 0.3s ease",
                boxShadow: step === idx ? "0 4px 12px rgba(30, 60, 115, 0.3)" : "none",
                transform: step === idx ? "scale(1.1)" : "scale(1)"
              }}>
                {step > idx ? "✓" : s.icon}
              </div>
              <div style={{
                textAlign: "center",
                fontSize: "0.75rem",
                fontWeight: step === idx ? 600 : 500,
                color: step === idx ? "#1E3C73" : "#6b7280",
                maxWidth: "120px",
                lineHeight: 1.3
              }}>
                <div>{s.title}</div>
                <div style={{
                  fontSize: "0.65rem",
                  opacity: 0.7,
                  marginTop: "0.15rem"
                }}>
                  {s.description}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Form Content */}
        <form onSubmit={handleSubmit} onKeyDown={handleFormKeyDown} style={{ padding: "2rem 2rem 1.5rem" }}>
          <div
            style={{
              minHeight: "400px",
              animation: "fadeIn 0.4s ease-in-out"
            }}
            role="region"
            aria-live="polite"
            aria-label={`Formulaire: ${steps[step].title}`}
          >
            {renderPage()}
          </div>
          {validationError && (
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              padding: "1rem 1.25rem",
              background: "#fef2f2",
              border: "2px solid #fecaca",
              borderRadius: "12px",
              color: "#dc2626",
              marginTop: "1.5rem",
              marginBottom: "1rem",
              position: "relative",
              animation: "slideInDown 0.3s ease-out"
            }}>
              <span style={{ fontSize: "1.25rem", flexShrink: 0 }}>⚠️</span>
              <span style={{ flex: 1, fontSize: "0.95rem", fontWeight: 500 }}>{validationError}</span>
              <button
                type="button"
                onClick={clearValidationError}
                aria-label="Fermer le message d'erreur"
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "1.5rem",
                  color: "#dc2626",
                  cursor: "pointer",
                  padding: "0 0.25rem",
                  lineHeight: "1",
                  opacity: 0.7,
                  transition: "opacity 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = "1"}
                onMouseOut={(e) => e.currentTarget.style.opacity = "0.7"}
              >
                ×
              </button>
            </div>
          )}

          {/* Navigation Buttons */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "2.5rem",
            paddingTop: "2rem",
            borderTop: "1px solid #e5e7eb",
            gap: "1rem"
          }}>
            <button
              type="button"
              onClick={handlePrev}
              disabled={step === 0 || isSubmitting}
              aria-label="Étape précédente"
              style={{
                padding: "0.875rem 1.5rem",
                borderRadius: "12px",
                border: "2px solid #e5e7eb",
                background: "white",
                color: "#374151",
                cursor: step === 0 || isSubmitting ? "not-allowed" : "pointer",
                fontSize: "1rem",
                fontWeight: 600,
                opacity: step === 0 || isSubmitting ? 0.4 : 1,
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                visibility: step === 0 ? "hidden" : "visible"
              }}
              onMouseOver={(e) => {
                if (step > 0 && !isSubmitting) {
                  e.currentTarget.style.background = "#f9fafb";
                  e.currentTarget.style.borderColor = "#d1d5db";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "white";
                e.currentTarget.style.borderColor = "#e5e7eb";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <span>←</span>
              <span>Retour</span>
            </button>

            <div style={{
              fontSize: "0.875rem",
              color: "#6b7280",
              fontWeight: 500
            }}>
              Étape {step + 1} sur {steps.length}
            </div>

            {step < steps.length - 1 ? (
              <button
                type="button"
                onClick={handleNext}
                disabled={isSubmitting}
                aria-label="Étape suivante"
                style={{
                  padding: "0.875rem 2rem",
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #1E3C73 0%, #2a5298 100%)",
                  color: "#FF9100",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  fontSize: "1rem",
                  fontWeight: 700,
                  opacity: isSubmitting ? 0.6 : 1,
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  boxShadow: "0 4px 12px rgba(30, 60, 115, 0.2)"
                }}
                onMouseOver={(e) => {
                  if (!isSubmitting) {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(30, 60, 115, 0.3)";
                  }
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(30, 60, 115, 0.2)";
                }}
              >
                <span>Suivant</span>
                <span>→</span>
              </button>
            ) : (
              <button
                type="submit"
                disabled={isSubmitting}
                aria-label="Envoyer le formulaire"
                style={{
                  padding: "0.875rem 2.5rem",
                  borderRadius: "12px",
                  border: "none",
                  background: isSubmitting 
                    ? "#6b7280"
                    : "linear-gradient(135deg, #FF9100 0%, #ffb347 100%)",
                  color: "white",
                  fontWeight: 700,
                  fontSize: "1.05rem",
                  cursor: isSubmitting ? "not-allowed" : "pointer",
                  opacity: isSubmitting ? 0.7 : 1,
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  boxShadow: "0 4px 12px rgba(255, 145, 0, 0.3)"
                }}
                onMouseOver={(e) => {
                  if (!isSubmitting) {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(255, 145, 0, 0.4)";
                  }
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 145, 0, 0.3)";
                }}
              >
                {isSubmitting ? (
                  <>
                    <span style={{
                      display: "inline-block",
                      width: "16px",
                      height: "16px",
                      border: "2px solid white",
                      borderTopColor: "transparent",
                      borderRadius: "50%",
                      animation: "spin 0.6s linear infinite"
                    }}></span>
                    <span>Enregistrement...</span>
                  </>
                ) : (
                  <>
                    <span>✓</span>
                    <span>Envoyer</span>
                  </>
                )}
              </button>
            )}
          </div>

          {/* CV Download Section - Only visible on last step after successful submission */}
          {step === steps.length - 1 && cvId && formSubmittedSuccessfully && (
            <div style={{
              marginTop: "2rem",
              padding: "1.5rem",
              background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
              borderRadius: "12px",
              border: "2px solid #0ea5e9",
              animation: "fadeIn 0.5s ease-out"
            }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                marginBottom: "1rem"
              }}>
                <span style={{ fontSize: "1.5rem" }}>🎉</span>
                <h3 style={{
                  margin: 0,
                  fontSize: "1.125rem",
                  fontWeight: 700,
                  color: "#1E3C73"
                }}>
                  Votre CV est prêt !
                </h3>
              </div>
              <p style={{
                margin: "0 0 1rem 0",
                fontSize: "0.875rem",
                color: "#64748b"
              }}>
                Téléchargez votre CV au format PDF ou convertissez-le en Word
              </p>
              <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
                <a
                  href={`${API_URL}/cv/generate/${cvId}/pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: "200px",
                    padding: "0.875rem 1.5rem",
                    background: "linear-gradient(135deg, #FF9100 0%, #ffb347 100%)",
                    color: "white",
                    borderRadius: "10px",
                    textDecoration: "none",
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    boxShadow: "0 4px 12px rgba(255, 145, 0, 0.3)",
                    transition: "all 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(255, 145, 0, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 145, 0, 0.3)";
                  }}
                >
                  <span>📄</span>
                  <span>Télécharger PDF</span>
                </a>
                <a
                  href="https://www.ilovepdf.com/fr/pdf_en_word"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: "200px",
                    padding: "0.875rem 1.5rem",
                    background: "linear-gradient(135deg, #1E3C73 0%, #2a5298 100%)",
                    color: "white",
                    borderRadius: "10px",
                    textDecoration: "none",
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    boxShadow: "0 4px 12px rgba(30, 60, 115, 0.2)",
                    transition: "all 0.2s"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(30, 60, 115, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(30, 60, 115, 0.2)";
                  }}
                >
                  <span>📝</span>
                  <span>Convertir en Word</span>
                </a>
              </div>
            </div>
          )}
        </form>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideInRight {
          from { transform: translateX(400px); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideInDown {
          from { transform: translateY(-20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        button:focus-visible, [role="button"]:focus-visible {
          outline: 3px solid #FF9100;
          outline-offset: 2px;
        }
        * {
          box-sizing: border-box;
        }
      `}</style>
    </div>
  );
};

const ConsultantForm: React.FC = () => {
  return (
    <FormProvider>
      <ConsultantFormContent />
    </FormProvider>
  );
};

export default ConsultantForm;
